import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { WebForum } from 'src/app/forum/web-forum';
import { getAssetUrl } from 'src/app/shared/asset';

@Component({
  selector: 'app-home-forum-item',
  templateUrl: './home-forum-item.component.html',
  styleUrls: ['./home-forum-item.component.scss'],
  standalone: false
})
export class HomeForumItemComponent implements OnInit {
  private router = inject(Router);

  @Input() forum: WebForum;

  ngOnInit() {}

  onClick(forumID: string) {
    this.router.navigate(['forum/' + forumID]);
  }

  getImageURL(imagePath: string): string {
    return getAssetUrl(imagePath);
  }
}
